import { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { buscarUsuarioAtual } from '../api/auth';
import { Usuario } from '../types';

interface AuthContextValue {
  usuario: Usuario | null;
  setUsuario: (usuario: Usuario | null) => void;
  carregando: boolean;
}

const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [usuario, setUsuario] = useState<Usuario | null>(null);
  const [carregando, setCarregando] = useState(true);

  useEffect(() => {
    buscarUsuarioAtual()
      .then((res) => setUsuario(res.usuario))
      .catch(() => setUsuario(null))
      .finally(() => setCarregando(false));
  }, []);

  return (
    <AuthContext.Provider value={{ usuario, setUsuario, carregando }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider.');
  }
  return context;
}
